import crawlApi, { type CrawlRequestBody } from './crawlApi';

const exportApi = crawlApi.injectEndpoints({
  endpoints: build => ({
    exportTable: build.mutation<unknown, CrawlRequestBody>({
      query: (body: CrawlRequestBody) => ({
        url: `/khazesh/v3/export/`,
        method: 'POST',
        body: body
      })
    })
  }),
  overrideExisting: false
});

export const { useExportTableMutation } = exportApi;
export default exportApi;
